export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_WITH_MICROSOFT = 'AUTH_WITH_MICROSOFT';
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const VERIFY_TWO_FACTOR_CODE = 'VERIFY_TWO_FACTOR_CODE';